import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import "../../styles/newbusiness.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { decryptFromStore, encryptAndStore } from "../../helper/sessionStore";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
const AIQuizChooseGuide = () => {
    const { t } = useTranslation("BusinessQuizChooseGuide");
    const [activeUser, setActiveUser] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const location = useLocation();
    const navigate = useNavigate();

    const handleNext = () => {
        if (!activeUser) {
            toast.error(t("please_select_user_to_proceed"));
            return;
        }
        setCurrentStep((prevStep) => (prevStep === 1 ? 2 : prevStep));
        window.scrollTo(0, 0);
    };

    // Function to handle setting the active user
    const handleUserClick = (user) => {
        setActiveUser(user);
        encryptAndStore("selectedUser", {
            user: user,
        });
    };

    useEffect(() => {
        sessionStorage.clear();
        if (!location?.state?.step) {
            navigate("/sign-in");
        }
        const getUser = decryptFromStore("selectedUser");
        if (getUser?.user) {
            setActiveUser(getUser.user);
        }
    }, []);

    return (
        <>
            <Header />
            <main className="business_puzzle business_choose_quiz">
                <section className="business_puzzle ">
                    <div className="container">
                        <div>
                            {currentStep === 1 && (
                                <div className="step-1">
                                    <div className="puzzle_top_box">
                                        <div className="row">
                                            <div className="col-8">
                                                <span>{t("quiz")} </span>
                                                <h2>
                                                    {t(
                                                        "choose_your_virtual_guide"
                                                    )}
                                                </h2>
                                                <p>
                                                    {t("choose_your_guide")} :
                                                    Ada or Ommo.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center mt-4 mt-lg-5 choose_quiz_user_box">
                                        <div className="col-12 col-lg-11">
                                            <div className="card mb-4 mb-lg-5">
                                                <div className="card-body p-0">
                                                    <div className="d-flex justify-content-evenly align-items-center">
                                                        <div className="choose_quiz_user_image">
                                                            <div
                                                                className={`choose_quiz_user_image_circle p-2 ${
                                                                    activeUser ===
                                                                    "Ada"
                                                                        ? "active"
                                                                        : ""
                                                                }`}
                                                                onClick={() =>
                                                                    handleUserClick(
                                                                        "Ada"
                                                                    )
                                                                }
                                                            >
                                                                <div className="bg-secondary w-100 h-100 d-flex justify-content-center align-items-center rounded-circle">
                                                                    <img
                                                                        src="/new-business/ada.webp"
                                                                        alt="Ada"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <p>Ada</p>
                                                        </div>

                                                        <div className="choose_quiz_user_image">
                                                            <div
                                                                className={`choose_quiz_user_image_circle p-2 ${
                                                                    activeUser ===
                                                                    "Ommo"
                                                                        ? "active"
                                                                        : ""
                                                                }`}
                                                                onClick={() =>
                                                                    handleUserClick(
                                                                        "Ommo"
                                                                    )
                                                                }
                                                            >
                                                                <div className="bg-secondary w-100 h-100 d-flex justify-content-center align-items-center rounded-circle">
                                                                    <img
                                                                        src="/new-business/ommo.webp"
                                                                        alt="Ommo"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <p>Ommo</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {currentStep === 2 && (
                                <div className="step-2">
                                    <div className="puzzle_top_box">
                                        <div className="row">
                                            <div className="col-8">
                                                <span>{t("quiz")} </span>
                                                <h2>{t("how_to_play")} </h2>
                                                <p>{t("explore_rules")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center mt-5 choose_quiz_user_box">
                                        <div className="col-12 col-lg-11">
                                            <div className="card mb-5">
                                                <div className="card-body">
                                                    <div className="row rules_box text-center g-3">
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            <img
                                                                src="/new-business/rules-1.webp"
                                                                className="pb-3"
                                                                width={162.2}
                                                                height={276}
                                                                alt=""
                                                            />
                                                            <p>
                                                                {t("game_goal")}
                                                            </p>
                                                        </div>
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            <img
                                                                src="/new-business/rules-2.webp"
                                                                className="pb-3"
                                                                width={162.2}
                                                                height={276}
                                                                alt=""
                                                            />
                                                            <p>
                                                                {t(
                                                                    "wrong_answer_consequence"
                                                                )}
                                                            </p>
                                                        </div>
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            <img
                                                                src="/new-business/rules-3.webp"
                                                                className="pb-3"
                                                                width={162.2}
                                                                height={276}
                                                                alt=""
                                                            />
                                                            <p>
                                                                {t(
                                                                    "joker_usage"
                                                                )}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="d-flex justify-content-end align-items-center gap-3 pb-5">
                                {currentStep === 1 ? (
                                    <button
                                        className="border-0"
                                        onClick={handleNext}
                                    >
                                        {t("next")}
                                    </button>
                                ) : (
                                    <Link
                                        to="/free-trail/gamified-quiz-start"
                                        state={{
                                            trailId: location?.state?.trailId,
                                            name: location?.state?.name,
                                            userData: location?.state?.userData,
                                        }}
                                        className="border-0"
                                    >
                                        {t("letsplay")}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default AIQuizChooseGuide;
